module.exports = __webpack_public_path__ + "img/WoPaid.0b43b4bd.png";